"use client";

import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Cloud, Lightbulb, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KeyFeatures() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const features = [{
    id: 1,
    icon: Users,
    title: "Proactive Accountants",
    description: "We are a firm of proactive accountants who work closely with you to make the preparation of your accounts, bookkeeping, VAT or tax return a highly beneficial process, not merely a mandatory one.",
    link: "/services#accountingbookkeeping"
  }, {
    id: 2,
    icon: Cloud,
    title: "Cloud Solutions",
    description: "Let us tailor a cloud solution to streamline your accounting and give you real time financial information. Access real-time insights with our integrated cloud accounting platforms, enabling smarter decisions anytime, anywhere.",
    link: "/CloudAccountingPage"
  }, {
    id: 3,
    icon: Lightbulb,
    title: "Tax & Advisory Excellence",
    description: "From comprehensive tax planning to sector-specific guidance, our experts ensure compliance while maximizing opportunities.",
    link: "/services#taxplanningandadvisory"
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="key-features" className="bg-background py-24 md:py-32">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={feature.id} ref={refs[i]} data-index={i} className="transition-all duration-500 ease-out" style={{
            opacity: visibilities[i] ? 1 : 0,
            transform: visibilities[i] ? "translateY(0)" : "translateY(20px)",
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="h-full hover:shadow-medium hover:-translate-y-0.5 transition-all duration-200 bg-surface border border-border group">
                  <CardHeader className="flex flex-col items-center text-center space-y-4">
                    <div className="w-16 h-16 rounded-full bg-primary-light flex items-center justify-center">
                      <Icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-2xl text-foreground">{feature.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="text-center">
                    <CardDescription className="text-muted-foreground leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="flex justify-center">
                    <Link to={feature.link} className="text-foreground font-medium relative inline-block after:absolute after:bottom-0 after:left-1/2 after:h-0.5 after:w-0 after:bg-accent after:transition-all after:duration-300 after:ease-out hover:after:w-full hover:after:left-0">
                      Learn More
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}